import React from "react"
import styled, { css } from "styled-components"

import LeadershipCard from "./leadership-card"
import BrianH from "@images/headshots/brianholland.jpg"
import Stan from "@images/headshots/stanholland.png"
import BrianM from "@images/headshots/brianmason.jpg"
import Emily from "@images/headshots/emilyfarley.jpg"
import Morgan from "@images/headshots/morgan-wise.png"
import Chrissy from "@images/headshots/chrissy-brown.png"
import Amanda from "@images/headshots/amanda-tucker.png"
import John from "@images/headshots/john-wines.png"
const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const Wrapper = styled.div`
  background-color: transparent;
  margin: 0;
  padding: 0;
`
const Container = styled.div`
  max-width: 1248px;
  margin: 0 auto;
  padding: 88px 48px;
  ${below.mobile`padding: 88px 24px;`}
  h2 {
    text-align: left;
    margin-bottom: 56px;
    ${below.tablet`margin-bottom: 48px;`}
    ${below.mobile`margin-bottom: 24px;`}
  }
  h3 {
    margin-bottom: 48px;
    ${below.mobile`
     margin-bottom: 24px;
     `}
  }
`
const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: flex-start;
  align-items: flex-start;
  ${below.mobile`margin-bottom: 24px; flex-direction: column;`}

  &.multi-row {
    ::after {
      content: "";
      padding: 0 44px;
      flex: 1;
    }
  }
`
const Leadership = props => {
  return (
    <>
      <Wrapper>
        <Container>
          <h2 className="fancy-type regular-weight">Owners and Executives</h2>
          <FlexContainer className="multi-row">
            <LeadershipCard
              name="Brian Holland"
              title="Chief Executive Officer"
              headshot={BrianH}
              bio="Brian Holland, CEO of Atlantic Bay Mortgage Group, founded the company in 1996. Prior to founding Atlantic Bay, Brian joined a mortgage company after graduating from Old Dominion University and in just three months became the assistant branch manager. Three years later, he opened Atlantic Bay’s doors.​"
            />
            <LeadershipCard
              name="Stan Holland"
              title="President"
              headshot={Stan}
              bio="Stan Holland, President, has more than 21 years in the mortgage industry. He is recognized by both his employees and competitors in the industry as a forward-thinking, team-oriented leader who wants the best for his company, employees and the local community. Stan’s retail mortgage product and program knowledge was critical in taking the company from broker to lender in 2003."
            />
            <LeadershipCard
              name="Brian Mason"
              title="Regional President & Partner"
              headshot={BrianM}
              bio="Brian Mason, Regional President and Partner, has more than 23 years in the mortgage industry. Brian’s entry into the mortgage industry was born out of his friendship with Brian Holland, Founder, President, and Chairman of Atlantic Bay Mortgage Group. The two future Atlantic Bay leaders met in 1988, and in 1996, Brian Mason joined as Regional President in opening Atlantic Bay. Brian continues to oversee sales strategy and business development in Western Virginia markets.​"
            />
          </FlexContainer>

          <h3 className="regular-weight fancy-type">
            Executive Leadership Team
          </h3>
          <FlexContainer className="multi-row">
            <LeadershipCard
              name="Morgan Wise"
              license="CPA"
              title="Chief Financial Officer"
              headshot={Morgan}
              bio="As the CFO, Morgan leads the financial, accounting, and servicing functions for Atlantic Bay. Morgan works closely with Capital Markets, Warehouse Lenders, and Investors to establish sound relationships. Morgan has more than 18 years of financial services experience with over 10 years in public accounting working with large regional banks, community banks, and mortgage entities.​"
            />
            <LeadershipCard
              name="Chrissy Zotzmann Brown"
              license="CMB, AMP, CRU"
              title="Chief Operations Officer"
              headshot={Chrissy}
              bio="Christina has oversight of Atlantic Bay’s operations, delivery, and governance across all retail products and programs. In this role, she is focused on providing a seamless, digital mortgage experience. Christina has more than 23 years of financial services lending experience and has worked for large banks, regional banks, brokerages, and independent mortgage bankers.​"
            />
            <LeadershipCard
              name="Emily Farley Gardner, CMA"
              title="Chief Lending Officer"
              headshot={Emily}
              bio="Emily leads Atlantic Bay’s National Sales function inclusive of Retail Sales Markets and Business Development. Emily is focused on guiding the enterprise sales growth of the organization. Emily has more than 18 years of experience in financial services and mortgage industry."
              license="NMLS #114245"
            />
            <LeadershipCard
              name="Amanda Tucker"
              license="CRCM, CAMS, CICA"
              title="Chief Risk & Compliance Officer"
              headshot={Amanda}
              bio="Amanda has oversight of Atlantic Bay’s Enterprise Risk Management, Regulatory and Operational Compliance, Legal, and Human Capital functions. Amanda’s focus is on a robust risk-based approach to compliance. Amanda has more than 16 years of experience in financial services both as a regulator and compliance professional working for regional and community banks."
            />
            <LeadershipCard
              name="John Wines"
              title="Chief Strategy Officer"
              headshot={John}
              bio="John’s mission is to equip the team at Atlantic Bay with the best tools and resources in the industry.  He leads the company’s Loan Innovation, Marketing, Information Technology, Data and Analytics, Project Management, Infrastructure, and Training departments.  John has been in the mortgage industry for over 20 years, working in all areas of the business including both Sales and Operations.​"
              license="NMLS #51552"
            />
          </FlexContainer>
        </Container>
      </Wrapper>
    </>
  )
}

export default Leadership
